const AppConfig = {
    PROTOCOL: "ws:",
    HOST: "//localhost",
    PORT: ":9999"
}

const Singleton = (function () {
    let instance;

    function createInstance() {
        const socket = new WebSocket(AppConfig.PROTOCOL + AppConfig.HOST + AppConfig.PORT);
        return socket;
    }

    function closesocket(socket){
        socket.close();
        instance = null;
    }

    return {
        getInstance: function () {
            if (!instance) {
                // console.log('no instance found');
                instance = createInstance();
            }
            return instance;
        },
        closeSocket: function(socket){
            closesocket(socket);
        }
    };
})();

export default Singleton;


// WEBPACK FOOTER //
// ./src/sock.js